import React from "react";
import { Container, Table, Badge } from "react-bootstrap";

// 🔹 Dados Fictícios de Logs
const logsData = [
  {
    id: 1,
    server: "SRV-APP-01",
    alert: "CPU acima de 90%",
    status: "Notificado",
    atendente: "Carlos Souza",
    tentativas: 1,
    chamadoPausado: "Não",
    criticidade: "Alta",
    horario: "29/01/2025 14:23",
  },
  {
    id: 2,
    server: "SRV-DB-02",
    alert: "Banco de Dados offline",
    status: "Confirmado",
    atendente: "Fernanda Lima",
    tentativas: 2,
    chamadoPausado: "Sim",
    criticidade: "Crítica",
    horario: "29/01/2025 15:10",
  },
  {
    id: 3,
    server: "SRV-WEB-03",
    alert: "Erro 500 na API",
    status: "Resolvido",
    atendente: "João Pereira",
    tentativas: 1,
    chamadoPausado: "Não",
    criticidade: "Média",
    horario: "29/01/2025 15:45",
  },
  {
    id: 4,
    server: "SRV-FILE-04",
    alert: "Espaço em disco crítico",
    status: "Pendente",
    atendente: "Em Análise",
    tentativas: 3,
    chamadoPausado: "Sim",
    criticidade: "Crítica",
    horario: "29/01/2025 16:12",
  },
];

// 🔹 Função para definir a cor do status
const getStatusVariant = (status) => {
  switch (status) {
    case "Notificado":
      return "primary";
    case "Confirmado":
      return "success";
    case "Pendente":
      return "warning";
    case "Resolvido":
      return "secondary";
    default:
      return "dark";
  }
};

// 🔹 Função para definir a cor da criticidade
const getCriticidadeVariant = (criticidade) => {
  switch (criticidade) {
    case "Baixa":
      return "success";
    case "Média":
      return "primary";
    case "Alta":
      return "warning";
    case "Crítica":
      return "danger";
    default:
      return "dark";
  }
};

const Logs = () => {
  return (
    <Container className="mt-4">
      <h2 className="mb-4 text-dark">📜 Logs de Alertas</h2>
      <Table striped bordered hover responsive>
        <thead className="table-dark">
          <tr>
            <th>#</th>
            <th>Servidor</th>
            <th>Alerta</th>
            <th>Status</th>
            <th>Atendente</th>
            <th>Tentativas</th>
            <th>Chamado Pausado?</th>
            <th>Criticidade</th>
            <th>Horário</th>
          </tr>
        </thead>
        <tbody>
          {logsData.map((log) => (
            <tr key={log.id}>
              <td>{log.id}</td>
              <td>{log.server}</td>
              <td>{log.alert}</td>
              <td>
                <Badge bg={getStatusVariant(log.status)}>{log.status}</Badge>
              </td>
              <td>{log.atendente}</td>
              <td>{log.tentativas}</td>
              <td>{log.chamadoPausado}</td>
              <td>
                <Badge bg={getCriticidadeVariant(log.criticidade)}>
                  {log.criticidade}
                </Badge>
              </td>
              <td>{log.horario}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default Logs;
